import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { lessonsAPI } from '../../services/api';
import './StudentPages.css';

const Lessons = () => {
  const { id } = useParams();
  const [course, setCourse] = useState(null);
  const [lessons, setLessons] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCourseData();
  }, [id]);

  const fetchCourseData = async () => {
    try {
      const response = await lessonsAPI.getCourse(id);
      setCourse(response.data.course);
      setLessons(response.data.lessons);
    } catch (error) {
      console.error('Course fetch error:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex-center" style={{ height: '50vh' }}>
        <div className="loading-spinner" />
      </div>
    );
  }

  if (!course) {
    return (
      <div className="empty-state">
        <p>Course not found</p>
        <Link to="/student/courses" className="btn btn-primary">
          Back to Courses
        </Link>
      </div>
    );
  }

  return (
    <div className="lessons-page fade-in">
      <Link to="/student/courses" className="back-link" style={{ marginBottom: '16px', display: 'inline-block' }}>
        ← Back to Courses
      </Link>

      <div className="course-detail-header" style={{
        background: 'linear-gradient(135deg, var(--color-secondary) 0%, #2d4a6f 100%)',
        color: 'white',
        padding: '32px',
        borderRadius: 'var(--radius-lg)',
        marginBottom: '24px'
      }}>
        <span className={`level-badge level-${course.level?.toLowerCase()}`} style={{ marginBottom: '12px' }}>
          {course.level}
        </span>
        <h1 style={{ fontSize: '28px', marginBottom: '8px' }}>{course.title}</h1>
        <p style={{ fontSize: '20px', opacity: '0.9', marginBottom: '16px' }}>{course.title_japanese}</p>
        <p style={{ opacity: '0.8' }}>{course.description}</p>
      </div>

      <h2 style={{ marginBottom: '16px' }}>📚 Lesson List</h2>

      <div className="lessons-list" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {lessons.map((lesson, index) => (
          <div 
            key={lesson.id} 
            className="lesson-item"
            style={{
              background: 'white',
              padding: '20px',
              borderRadius: 'var(--radius-lg)',
              display: 'flex',
              alignItems: 'center',
              gap: '20px',
              boxShadow: 'var(--shadow-sm)'
            }}
          >
            <div 
              className="lesson-number"
              style={{
                width: '48px',
                height: '48px',
                background: 'var(--color-primary)',
                color: 'white',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '700',
                fontSize: '18px'
              }}
            >
              {index + 1}
            </div>
            <div className="lesson-content" style={{ flex: 1 }}>
              <h3 style={{ marginBottom: '4px' }}>{lesson.title}</h3>
              <p style={{ color: 'var(--color-primary)', fontSize: '14px', marginBottom: '4px' }}>
                {lesson.title_japanese}
              </p>
              <p style={{ color: 'var(--color-text-light)', fontSize: '13px' }}>
                {lesson.description}
              </p>
            </div>
            <div className="lesson-meta" style={{ textAlign: 'right' }}>
              <span style={{ fontSize: '13px', color: 'var(--color-text-light)' }}>
                ⏱️ {lesson.duration_minutes || 60} min
              </span>
            </div>
            <button className="btn btn-outline btn-sm">
              Start
            </button>
          </div>
        ))}
      </div>

      {lessons.length === 0 && (
        <div className="empty-state">
          <p>No lessons available yet</p>
          <p className="text-muted">Please check back later.</p>
        </div>
      )}
    </div>
  );
};

export default Lessons;
